import React, {ChangeEvent} from "react";
import {IntlMessageValue, UniCol, UniForm, UniRow} from "../../../../../@WUM/core/Elements";
import UniChecks from "../../../../../@WUM/core/Elements/Form/Elements/Check";

interface AllowForceBreak {
    value: any;
    onChange: (data: { name: string; value: string | boolean }) => void;
}

const ForceBreak = (Props: AllowForceBreak) => {

    const handleSwitch = (event: ChangeEvent<Element>) => {
        const target = event.target as HTMLInputElement;
        Props.onChange({name: target.name, value: target.checked});
    };

    const handleInput = (event: ChangeEvent<Element>) => {
        const target = event.target as HTMLInputElement;
        Props.onChange({name: target.name, value: target.value});
    };

    const allow =
        Props.value?.forceBreak?.forceBreakActive ??
        Props.value?.forceBreakActive ??
        false;

    return (
        <>
            <div>
                <div>
                    <UniChecks
                        type="switch"
                        label={IntlMessageValue("", "time.settings.force-break", "")}
                        name="forceBreakActive"
                        checked={Props?.value?.forceBreakActive}
                        class={"uni-switch ps-0 mb-3"}
                        onChange={handleSwitch}
                        info={{text: "time.settings.force-break.helper"}}
                    />
                </div>
                {allow && (
                    <UniRow>
                        <UniCol>
                            <UniForm.InputGroup class={"mb-md-0 mb-3"}>
                                <UniForm.InputGroupText
                                    class={""}
                                    text={IntlMessageValue("", "time.settings.breaktime-mandatory", "")}
                                />
                                <UniForm.FormControl
                                    type="number"
                                    name="breaktime-mandatory"
                                    placeholder={IntlMessageValue("", "time.settings.placeholder.breaktime-mandatory", "")}
                                    defaultValue={Props?.value?.forceBreakAfter}
                                    min={0}
                                    max={10}
                                    required
                                    onChange={handleInput}
                                    step={0.5}
                                />
                                <UniForm.InputGroupText
                                    class={""}
                                    text={"h"}
                                />
                                <UniForm.InputGroupHelpText text={"time.settings.breaktime-mandatory.helper"}
                                                            class={"p-0 pe-1"} Store={""}/>
                                <UniForm.ControlFeedback
                                    text={IntlMessageValue("", "time.settings.error.breaktime-force-min", "")}/>
                            </UniForm.InputGroup>

                        </UniCol>
                        <UniCol>

                            <UniForm.InputGroup class={"mb-md-0 mb-3"}>

                            <UniForm.InputGroupText
                                class={""}
                                text={IntlMessageValue("", "time.settings.breaktime-min", "")}
                            />
                            <UniForm.FormControl
                                type="number"
                                name="breaktime-min"
                                placeholder={IntlMessageValue("", "time.settings.placeholder.breaktime-min", "")}
                                defaultValue={Props?.value?.forceBreakTime}
                                min={15}
                                max={120}
                                required
                                onChange={handleInput}
                                step={0.5}
                            />
                            <UniForm.InputGroupText
                                class={""}
                                text={"min"}
                            />
                            <UniForm.InputGroupHelpText text={"time.settings.breaktime-min.helper"} class={"p-0 pe-1"}
                                                        Store={""}/>
                            <UniForm.ControlFeedback
                                text={IntlMessageValue("", "time.settings.error.breaktime-min", "")}/>
                        </UniForm.InputGroup>
                    </UniCol>
                    </UniRow>

                    )}
            </div>

        </>
    )
}
export default ForceBreak;
